import { useRef, createContext, LegacyRef, useState, RefObject, MutableRefObject } from 'react';
import { ITrackId } from '../models/Selection';

interface TimelineContainerContextType {
	trackContentContainerRef: RefObject<HTMLDivElement> | null;
	timelineScrollDivRef: RefObject<HTMLDivElement> | null;
	audioTrackPositionsRef: MutableRefObject<
		{ trackId: ITrackId; yMin: number; yMax: number }[]
	> | null;
	timelineScale: number;
	setTimelineScale: (value: number) => void;
}

export const TimelineContainerContext = createContext<TimelineContainerContextType>({
	trackContentContainerRef: null,
	timelineScrollDivRef: null,
	audioTrackPositionsRef: null,
	timelineScale: 10,
	setTimelineScale: (value) => {},
});

export const TimelineContainerContextStore = (props: any) => {
	const trackContentContainerRef = useRef<HTMLDivElement>(null);
	const timelineScrollDivRef = useRef<HTMLDivElement>(null);
	const audioTrackPositionsRef = useRef<{ trackId: ITrackId; yMin: number; yMax: number }[]>([]);
	const [timelineScale, setTimelineScale] = useState<number>(10); // px per second

	return (
		<TimelineContainerContext.Provider
			value={{
				trackContentContainerRef,
				timelineScrollDivRef,
				audioTrackPositionsRef,
				timelineScale,
				setTimelineScale,
			}}
		>
			{props.children}
		</TimelineContainerContext.Provider>
	);
};
